<template>
<div>
  <Grid name="modaloperatorsGrid" ref="modaloperatorsGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import lists from '@/components/States.js'
export default {
  name: 'Client',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        },
        'operator_group_id': {
          type: 'number'
        }
      },
      url: 'operators',
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      },{
        api: 'operator_groups/lst',
        field: 'operator_group_id'
      }],
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Selecionar',
          click: this.selectItem
        }
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'nif',
        title: 'NIF',
        width: '120px'
      },
      {
        field: 'le',
        title: 'LE',
        width: '80px'
      },
      {
        field: 'codle',
        title: 'CODLE',
        width: '120px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        values:[],
        width: '180px'
      },
      {
        field: 'operator_group_id',
        title: 'Grupo Operadores',
        values:[],
        width: '180px'
      },
      {
        field: 'unidentified',
        title: 'Não Identificado',
        values: lists.yesNo,
        width: '80px'
      },
      {
        field: 'old_id',
        title: 'ID v1',
        width: '80px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    selectItem(e) {
      e.preventDefault()
      var grid = this.$refs.modaloperatorsGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('select-item', {
        item: dataItem
      })
    }
  }
}
</script>
